<template>
  <div>
    <div class="header">
      <div class="row">
        <div class="small-12 columns">
          <span class="tab-message show-for-medium">Your <span v-if="showYourPartnerTab">partner's</span> contributions</span>

          <ul class="tabs tabs-partner" v-if="includePartner">
            <li class="tabs-title" :class="{ 'is-active': !showYourPartnerTab }">
              <a aria-selected="true" @click.prevent="actionShowYourPartnerTab({ value: false })">You</a>
            </li>
            <li class="tabs-title" :class="{ 'is-active': showYourPartnerTab }">
              <a aria-selected="true" @click.prevent="actionShowYourPartnerTab({ value: true })">Your partner</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <section>
      <p class="section-content">See the effect of changing your regular contributions and making a one-off lump sum contribution on your retirement income. </p>
      <div class="tabs-content">
        <div class="tabs-panel" :class="{ 'is-active': !showYourPartnerTab || !includePartner }">
          <div class="row">
            <div class="small-12 medium-12 columns">
              <h2 class="section-sub-heading">Your employment contributions</h2>
            </div>
          </div>

          <employment-inputs></employment-inputs>

          <hr />

          <div class="row">
            <div class="small-12 medium-12 columns">
              <h2 class="section-sub-heading">Your additional contributions</h2>
            </div>
          </div>

          <additional-contribution-inputs></additional-contribution-inputs>
        </div>

        <div class="tabs-panel" :class="{ 'is-active': showYourPartnerTab }" v-if="includePartner">
          <div class="row">
            <div class="small-12 medium-12 columns">
              <h2 class="section-sub-heading">Your partner's employment contributions</h2>
            </div>
          </div>

          <employment-inputs :modifier="partnerModifier"></employment-inputs>

          <hr />

          <div class="row">
            <div class="small-12 medium-12 columns">
              <h2 class="section-sub-heading">Your partner's additional contributions</h2>
            </div>
          </div>

          <additional-contribution-inputs :modifier="partnerModifier"></additional-contribution-inputs>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Constants, EmployerType } from '@/constants';

export default {
  components: {
    EmploymentInputs: require('../../inputs/EmploymentInputs').default,
    AdditionalContributionInputs: require('../../inputs/AdditionalContributionInputs').default,
  },
  data() {
    return {
      partnerModifier: Constants.PARAMETER_PARTNER_SUFFIX,
    };
  },
  computed: {
    ...mapState(['inputs', 'inferred', 'ui']),
    showYourPartnerTab() {
      return this.ui.showYourPartnerTab.value;
    },
    includePartner() {
      return this.inputs.IncludePartner.value;
    },
    EmployerType() {
      return this.inferred[`EmployerType${Constants.PARAMETER_SUBJECT_SUFFIX}`].value;
    },
    PartnerEmployerType() {
      return this.inferred[`EmployerType${Constants.PARAMETER_PARTNER_SUFFIX}`].value;
    },
    isNotSelfEmployed() {
      return this.EmployerType !== EmployerType.SELF_OR_NOT_EMPLOYED;
    },
    partnerIsNotSelfEmployed() {
      return this.PartnerEmployerType !== EmployerType.SELF_OR_NOT_EMPLOYED;
    },
  },
  methods: {
    ...mapActions([
      'actionShowYourPartnerTab',
    ]),
  },
};
</script>
